import React from 'react';

import {
  ErrorBoundaryImg,
  ErrorBoundaryText,
  ErrorBoundaryTitle,
  ErrorBoundaryWrapper,
} from './error-boundary.ui';

const DefaultFallback: React.FC = () => {
  return (
    <ErrorBoundaryWrapper>
      <ErrorBoundaryImg />
      <ErrorBoundaryTitle>Hmm, something seems to be missing</ErrorBoundaryTitle>
      <ErrorBoundaryText>
        We&apos;re having a little trouble showing the information you requested. <br />
        Try refreshing the page, or check back later.
      </ErrorBoundaryText>
    </ErrorBoundaryWrapper>
  );
};

export default DefaultFallback;
